


























































































































import Vue from "vue";
import Component from "vue-class-component";
import REQ_URL from "@/consts/req-url";
import cookie from "@/api/cookie";
import storageObservable from "@/api/storageObservable";
import { Watch, Model } from "vue-property-decorator";
import { profileColor, profileAbb } from "@/api/graphicIdentifier";

@Component({})
export default class ProfileMenu extends Vue {
  @Model("change", { type: Boolean }) show!: boolean;
  get swSupport() {
    return this.$store.state.network.swSupport
  }
  get offMode() {
    return this.$store.getters.offlineMode;
  }
  set offMode(val: boolean) {
    this.$store.dispatch("setOfflineMode", val);
  }
  async logout() {
    try {
      await this.$fetch(REQ_URL.LOGOUT);
    } catch (error) {
      cookie.deleteCookie("PHPSESSID");
    }

    storageObservable.emit("logout", {
      logout: true
    });

    this.$store.dispatch("logout");
    this.$router.push({ name: "login" });
  }
  subscribeOnMessage() {
    storageObservable.subscribe("logout", () => {
      this.$store.dispatch("logout");
      this.$router.push({ name: "login" });
    });
  }
  profileColor = profileColor;
  profileAbb = profileAbb;
  exitFromManagerClient() {
    this.$store.dispatch("exitManagerClient");
    this.$router.push({ path: "/my-profile/clients" });
    this.$emit("change", false);
  }
  created() {
    let offlineMode = false;
    if (localStorage && localStorage.getItem("offlineMode")) {
      let offlineModeState = (JSON.parse(localStorage.getItem(
        "offlineMode"
      ) as string) as { status: boolean; user: string }[]).find(
        state => state.user === this.$store.getters.profile.email
      );
      if (offlineModeState) offlineMode = offlineModeState.status;
    }
    this.offMode = offlineMode;
    this.subscribeOnMessage();
  }
}
